import { useAuthState } from 'state/auth';
import { getFromLocalStorage, removeFromLocalStorage } from 'global/utils/storage';
import { AUTH_TOKEN } from 'config/constant';
import { useNavigate } from 'react-router';
import { useQuery } from 'react-query';
import { GET_USER_INFO_KEY } from 'api/auth';
import { api } from 'api/api';
import { RoutesSettings } from 'config/routes';
import { useEffect, useCallback, useState } from 'react';
import { isNullOrUndefined } from 'global/utils/common';

export const useAuth = () => {
  const navigate = useNavigate();
  const { isAuthenticated, onLogout, onSignInSuccess, user } = useAuthState();
  const ticket = getFromLocalStorage(AUTH_TOKEN);
  const [isLoading, setIsLoading] = useState(true);

  const invalidUserAction = useCallback(() => {
    removeFromLocalStorage(AUTH_TOKEN);
    navigate(RoutesSettings.signIn, { replace: true });
    onLogout();
  }, []);

  const { refetch: getUserInfo } = useQuery(GET_USER_INFO_KEY, () => api.auth.getUserInfo(), {
    enabled: false,
    onSettled: response => {
      if (!isNullOrUndefined(response) && !response?.hasError()) {
        onSignInSuccess(response?.data?.user!);
        return;
      }

      invalidUserAction();
    },
  });

  useEffect(() => {
    if (isAuthenticated) {
      setIsLoading(false);
      return;
    }

    if (ticket) {
      getUserInfo();
      return;
    }

    invalidUserAction();
  }, [isAuthenticated]);

  return { isAuthenticated, isLoading, user };
};
